import { createSlice } from "@reduxjs/toolkit";

export const modulosSlice = createSlice({
    name: 'modulos',
    initialState: {
        moduloEmpresa: [],
        modulosOg1: [],
    },
    reducers: {
        addModuloEmpresa: (state, action) => {
            state.moduloEmpresa = action.payload
        },
        addModulosOg1: ( state, action) => {
            state.modulosOg1 = action.payload
        },
    },
});

export const { addModuloEmpresa, addModulosOg1 } = modulosSlice.actions;
export default modulosSlice.reducer;